<template>
  <div>
    <v-chart
      class="chart mt-4 mb-6"
      :option="option"
      :update-options="{replaceMerge: 'series'}"
      :theme="$vuetify.theme.dark ? themeDark : themeLight"
      autoresize
    />

    <v-row>
      <v-col
        class="pa-0 ma-0"
        cols="6"
      >
        <newsletter-results-card
          :title="$t('label.newsletter_results_open_rate')"
          :value="stats.or"
        />
      </v-col>
      <v-col
        class="pa-0 ma-0"
        cols="6"
      >
        <newsletter-results-card
          :title="$t('label.newsletter_results_ctr')"
          :value="stats.ctr"
        />
      </v-col>
      <v-col
        class="pa-0 ma-0"
        cols="6"
      >
        <newsletter-results-card
          :title="$t('label.newsletter_results_ctor')"
          :value="stats.ctor"
        />
      </v-col>

      <v-col
        class="pa-0 ma-0"
        cols="6"
      >
        <newsletter-results-card
          :title="$t('label.newsletter_results_7_day_conversion')"
          :value="stats.cr"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script setup lang="ts">
import { PropType, ref, watch } from 'vue';
import themeDark from '@/../static/chart-dark.json';
import themeLight from '@/../static/chart-light.json';
import { use } from 'echarts/core';
import { FunnelChart } from 'echarts/charts';
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
} from 'echarts/components';
import VChart from 'vue-echarts';
import { TranslateResult } from 'vue-i18n';
import NewsletterResultsCard from './NewsletterResultsCard.vue';

use([
  FunnelChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
]);

const props = defineProps({
  dataset: {
    type: Array as PropType<Array<{value: number[], name: string | TranslateResult, unit?: string}>>,
    default: () => [],
  },
  stats: {
    type: Object as PropType<{
      or: string, ctr: string, ctor: string, cr: string, tr: string, tg: string
    }>,
    required: true,
  },
});

const createDataset = () => ({
  grid: {
    left: '8px',
    top: '8px',
    right: '8px',
    bottom: '8px',
  },
  series: [
    {
      gap: 6,
      color: ['#3355ff', '#0085f5', '#0099ae', '#33b58c', '#00714e'],
      name: 'Funnel',
      type: 'funnel',
      maxSize: '90%',
      left: '0%',
      right: '0%',
      top: '0%',
      label: {
        position: 'inside',
        color: 'black',
        backgroundColor: '#fefefe',
        borderWidth: 1,
        borderColor: '#D6D6D8',
        borderRadius: 6,
        padding: [4, 8],
        // eslint-disable-next-line vue/max-len
        formatter: (o: any) => `{b|${o.data.name}} - ${o.data.value[0]} ${o.dataIndex === 0 ? '' : `{s|(${o.data.value[1].toFixed(1)}%)}`}`,
        textBorderColor: 'none',
        textBorderWidth: 0,
        rich: {
          b: {
            fontWeight: 'bold',
          },
          m: {
            fontWeight: '600',
          },
          s: {
            color: '#3F3F49',
          },
        },
      },
      data: props.dataset,
    },
  ],
});

const option = ref(createDataset());

const reset = () => { option.value = createDataset(); };

watch(() => props.dataset, () => reset());

</script>

<style scoped>

  .chart {
    height: 300px;
  }

</style>
